/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
function identity<T>(value: T) {
  return value;
}

export default identity;
